/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Loudness_AnalyzingInputs */

const en_audio_description_export_loudness_analyzing = /** @type {(inputs: Audio_Description_Export_Loudness_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing audio loudness...`)
};

const fr_audio_description_export_loudness_analyzing = /** @type {(inputs: Audio_Description_Export_Loudness_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse du niveau sonore...`)
};

const de_audio_description_export_loudness_analyzing = /** @type {(inputs: Audio_Description_Export_Loudness_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse der Audiolautstärke...`)
};

const it_audio_description_export_loudness_analyzing = /** @type {(inputs: Audio_Description_Export_Loudness_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi del volume audio...`)
};

const ru_audio_description_export_loudness_analyzing = /** @type {(inputs: Audio_Description_Export_Loudness_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Анализ громкости звука...`)
};

const es_audio_description_export_loudness_analyzing = /** @type {(inputs: Audio_Description_Export_Loudness_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizando la sonoridad del audio...`)
};

const zh_cn2_audio_description_export_loudness_analyzing = /** @type {(inputs: Audio_Description_Export_Loudness_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分析音频响度……`)
};

const ja_audio_description_export_loudness_analyzing = /** @type {(inputs: Audio_Description_Export_Loudness_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオの音量を分析しています...`)
};

const hi_audio_description_export_loudness_analyzing = /** @type {(inputs: Audio_Description_Export_Loudness_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो की तीव्रता का विश्लेषण किया जा रहा है...`)
};

const pt_pt2_audio_description_export_loudness_analyzing = /** @type {(inputs: Audio_Description_Export_Loudness_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisando a intensidade sonora...`)
};

/**
* | output |
* | --- |
* | "Analyzing audio loudness..." |
*
* @param {Audio_Description_Export_Loudness_AnalyzingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_loudness_analyzing = /** @type {((inputs?: Audio_Description_Export_Loudness_AnalyzingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Loudness_AnalyzingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_loudness_analyzing(inputs)
	if (locale === "de") return de_audio_description_export_loudness_analyzing(inputs)
	if (locale === "it") return it_audio_description_export_loudness_analyzing(inputs)
	if (locale === "ru") return ru_audio_description_export_loudness_analyzing(inputs)
	if (locale === "es") return es_audio_description_export_loudness_analyzing(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_loudness_analyzing(inputs)
	if (locale === "ja") return ja_audio_description_export_loudness_analyzing(inputs)
	if (locale === "hi") return hi_audio_description_export_loudness_analyzing(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_loudness_analyzing(inputs)
	return en_audio_description_export_loudness_analyzing(inputs)
});